import { StateCreator } from 'zustand';
import { SelectedLoanSimulationSlice } from './selected-loan-simulation.types';

export const createSelectedLoanSimulationSlice: StateCreator<
  SelectedLoanSimulationSlice,
  [],
  [],
  SelectedLoanSimulationSlice
> = () => ({
  loanSimulation: null,
});
